import { render, staticRenderFns } from "./opened-character.vue?vue&type=template&id=319a167c&"
import script from "./opened-character.vue?vue&type=script&lang=js&"
export * from "./opened-character.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports